import required from "vuelidate/lib/validators/required";
import maxlength from "vuelidate/lib/validators/maxLength";

import FieldText from "@components/molecules/m-field-text.vue";

export default {
  component: FieldText,
  attrs: {
    label: "Número",
    name: "numero",
    class: ["numero"],
    placeholder: "00",
    type: "tel",
    mask: ["##########"],
    required: true,
    maxlength: 10,
  },
  errorMessages: [
    {
      name: "required",
      message: "É preciso informar o nº do endereço.",
    },
    {
      name: "maxlength",
      message: "precisa ter no máximo 10 dígitos!",
    },
  ],
  validation: {
    required,
    maxlength: maxlength(10),
  },
};
